import cx from 'classnames';
import React from 'react';

import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import './detailed-view.scss';

interface Props {
    children: React.ReactNode | Array<React.ReactNode>;
    mix?: string;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const LessonViewDetailedView = React.forwardRef<HTMLDivElement, Props>(({ children, mix, onClick }, ref) => {
    return (
        <div className={cx('detailed-view', mix)} ref={ref} {...accessibleClick(onClick)}>
            {children}
        </div>
    );
});
